"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// calculates the total price for the cruise
function insurancePrice(_state, getters) {
    // determine price for insurances
    var insurance = getters['insurance/totalPrice'] || 0;
    // return sum
    return insurance;
}
exports.default = insurancePrice;
//# sourceMappingURL=insurance_price.js.map